<template>
    <div class="filters__bit">
        <div class="title trigger-collapse trigger-plus">
            <span class="filter-title">Extras</span>
            <img class="icon-dropdown float-right" src="/assets/images/helpers/icon-dropdown.svg" alt="">
        </div>
        <div class="collapse">
            <ul class="list__bit p-0 bullet-none m-0">
                <li class="item">
                    <input v-model="filters.one_owner" class="form-input-checkbox hidden" type="checkbox" name="plus-one_owner"  id="plus-one_owner">
                    <label for="plus-one_owner" class="checkbox-mark">
                        Único dueño
                    </label>
                </li>
                <li class="item">
                    <input v-model="filters.invoice" class="form-input-checkbox hidden" type="checkbox" name="plus-invoice"  id="plus-invoice">
                    <label for="plus-invoice" class="checkbox-mark">
                        Factura original
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {

    data: () => ({
        filters: {
            one_owner  : null,
            invoice    : null,
            user_verify: null,
        }
    }),

    watch: {

        'filters': {
            handler(newValue){
                let vm = this;
                this.$emit('change', 'plus', newValue);
            }, deep: true
        },

    }
}
</script>